import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './styles.scss';
export const InlineIcon = ({ className, icon, ...props }) => (React.createElement("div", { className: classnames(className, styles.icon), role: "presentation", ...props }, icon));
InlineIcon.propTypes = {
    className: PropTypes.string,
    icon: PropTypes.node,
};
//# sourceMappingURL=inline-icon.js.map